import { type ProspectTaskDto, type TaskCreateDto } from "@crowdcoursing/api/openapi";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";

import { TaskForm } from "~ui/molecules/TaskForm/TaskForm";
import { useTaskAssigneeOptions } from "~ui/molecules/TaskForm/useTaskAssigneeOptions";

interface TaskModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (values: TaskCreateDto) => Promise<void>;
  task?: ProspectTaskDto;
  title?: string;
}

export const TaskModal = ({ open, onClose, onSubmit, task, title = "Add Task" }: TaskModalProps) => {
  const { assigneeOptions, currentUserId } = useTaskAssigneeOptions(open, task);
  const handleSubmit = async (values: TaskCreateDto) => {
    try {
      await onSubmit(values);
      onClose();
    } catch (error) {
      console.error("Error submitting task:", error);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Box pt={2}>
          <TaskForm
            assigneeOptions={assigneeOptions}
            defaultAssigneeId={currentUserId}
            initialValues={task}
            onSubmit={handleSubmit}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" type="submit" form="task-form">
          {task ? "Update" : "Create"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
